module.exports = __webpack_public_path__ + "img/f75076e.jpg";